module.exports = __webpack_public_path__ + "media/images/vp/icon.heart.white-7489a003b7cd23e4cdd98e71e9a8b43c.svg";